class AurumHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-aurum-menu-toggle]');
    this.drawer = this.querySelector('[data-aurum-menu-drawer]');
    this.toggle?.addEventListener('click', this.onToggle);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
  }

  onToggle = () => {
    const isOpen = this.getAttribute('data-menu-open') === 'true';
    this.setAttribute('data-menu-open', String(!isOpen));
    this.toggle?.setAttribute('aria-expanded', String(!isOpen));
  };
}

class AurumCalculator extends HTMLElement {
  connectedCallback() {
    this.inputs = Array.from(this.querySelectorAll('[data-aurum-calc-input]'));
    this.output = this.querySelector('[data-aurum-calc-output]');
    this.inputs.forEach((input) => input.addEventListener('input', this.calculate));
    this.calculate();
  }

  disconnectedCallback() {
    this.inputs.forEach((input) => input.removeEventListener('input', this.calculate));
  }

  calculate = () => {
    if (!this.output) return;

    const principal = this.valueFor('initial');
    const monthly = this.valueFor('monthly');
    const years = Math.max(this.valueFor('years'), 0);
    const annualGrowth = this.valueFor('growth') / 100;
    const annualFee = this.valueFor('fees') / 100;
    const monthlyRate = (annualGrowth - annualFee) / 12;
    const months = Math.round(years * 12);
    let value = principal;

    for (let index = 0; index < months; index += 1) {
      value = (value + monthly) * (1 + monthlyRate);
    }

    this.output.textContent = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'GBP',
      maximumFractionDigits: 0,
    }).format(Math.max(value, 0));
  };

  valueFor(name) {
    const input = this.querySelector(`[data-aurum-calc-input="${name}"]`);
    return Number.parseFloat(input?.value || '0') || 0;
  }
}

if (!customElements.get('aurum-header')) {
  customElements.define('aurum-header', AurumHeader);
}

if (!customElements.get('aurum-calculator')) {
  customElements.define('aurum-calculator', AurumCalculator);
}

(() => {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  const selectors = [
    '.shopify-section > section',
    '.aurum-site-header__mega-column',
    '.transparent-metal-products__card',
    '.rainy-day-fund-stats__card',
    '.gold-saving-plans__calculator',
    '.gold-saving-plans__calc-sentence',
    '.final-objections-faq__item',
    '.aurum-buy-gold .abg-main > section',
    '.aurum-buy-silver .abs-main > section',
    '.aurum-saver > section',
    '.aurum-featured-body > section',
    '.aurum-discover > section',
    '.aurum-reference-body > section',
    '.aurum-faq-page main > section',
    '.aurum-contact-page main > section',
    '.aurum-new-to-investing main > section',
    '.afb-category-card',
    '.abg-product-card',
    '.abs-product-card'
  ];

  const targets = document.querySelectorAll(selectors.join(','));
  if (!targets.length || !('IntersectionObserver' in window)) {
    targets.forEach((target) => target.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  targets.forEach((target, index) => {
    target.classList.add('aurum-reveal');
    target.style.transitionDelay = `${Math.min(index % 4, 3) * 55}ms`;
    observer.observe(target);
  });
})();
